import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useNavigate, Navigate } from "react-router-dom";

import "primereact/resources/themes/tailwind-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./output.css";
import "./App.css";

import GlobalContext                from "../isp._comun/contexto/GlobalContext";
import PantallaInteractivaDeLogueo  from "../isp.pantalla.logueo/componentes/PantallaInteractivaDeLogueo";
import PantallaInteractivaPrincipal from "../isp.pantalla.principal/componentes/PantallaInteractivaPrincipal";

// import * as Evento from "./comun/Eventos";
/** @returns {React.element}  PresentadorAppEnrutado */
/** @returns {React.element}  PresentadorApp*/

function App() {
    return (
        <BrowserRouter>
            <React.StrictMode>
                <RutasDelApp />
            </React.StrictMode>
        </BrowserRouter>
    );
}

/** @returns {React.element}  PresentadorApp*/
function RutasDelApp() {
    const [usuario, setUsuario] = useState(null);
    //useNavigate solo puede usarse en un contexto dentro de un BrowserRouter
    const navigate = useNavigate();

    if (usuario === null) {
        const cargarPantallaPrincipal = (usuario) => {
            setUsuario(usuario);
            navigate("/", { replace: true });
        };

        /* const presentadorLogueo = (
            <PresentadorLogueo
                cargarPantallaPrincipal={cargarPantallaPrincipal}
            />
        ); */
        const pantallaInteractivaDeLogueo = (
            <GlobalContext.Provider value={{cargarPantallaPrincipal}}>
                <PantallaInteractivaDeLogueo
                    cargarPantallaPrincipal={cargarPantallaPrincipal}
                />
            </GlobalContext.Provider>
        );
        return RutasALaPantallaInteractivaDeLogueo(pantallaInteractivaDeLogueo);
        // return RutasAlPresentadorLogueo(presentadorLogueo);
    
    } else {
        const cargarPantallaLogin = () => {
            setUsuario(null);
            navigate("/login", { replace: true });
        };

        const contextoGlobal = (
            <GlobalContext.Provider value={{ cargarPantallaLogin, usuario }}>
                <PantallaInteractivaPrincipal />
            </GlobalContext.Provider>
        );
        return RutasALaPantallaInteractivaPrincipal(contextoGlobal);
    }
}

function RutasALaPantallaInteractivaDeLogueo(pantallaInteractivaDeLogueo) {
    return (
        <Routes>
            <Route path="/login" element={pantallaInteractivaDeLogueo} />
            <Route path="*" element={<Navigate to="login" />} />
        </Routes>
    );
}

function RutasALaPantallaInteractivaPrincipal(pantallaInteractivaPrincipal) {
    return (
        <Routes>
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/" element={pantallaInteractivaPrincipal} />
        </Routes>
    );
}

export default App;
